import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { ToastContainer } from "react-toastify";
import { getBaseApiUrl } from '../../utils/apiendpoint.utils'
import { changePassword } from "../../utils/wellspoken.api";

const ChangePassword = () => {
    const { sfntapi } = getBaseApiUrl;
    const [isOldPass, setOldPass] = useState("");
    const [isEmail, setEmail] = useState("");
    const [isnewPass, setnewPass] = useState("");
    const [isnewPassConf, setnewPassConf] = useState("");
    const [loading, setLoading] = useState(false);
    const toastBR = useRef(null);
    const [errors, setErrors] = useState({});

    const showSuccess = () => {
        toastBR.current.show({
            severity: "success",
            summary: "Success",
            detail: "Password change successfully!",
            life: 5000,
        });
    };

    const showError = (message) => {
        toastBR.current.show({
            detail: message,
            life: 5000,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            oldPassword: isOldPass.trim(),
            toEmail: isEmail.trim(),
            newPassword: isnewPass.trim(),
            confirmPassword: isnewPassConf.trim(),
        };
        try {
            const response = await fetch(`${sfntapi}/api/ChangePassword`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Failed to change password");
            }

            const data = await response.json();
            console.log(data);
            showSuccess();
        } catch (error) {
            console.error(error);
            showError(error.message);
        } finally {
            setLoading(false);
        }
    };
    const validation = () => { };

        return (
            <section
                className="mt-1 px-4"
                aria-labelledby="change-password-heading"
            >
                <main
                    className="
        max-w-3xl mx-auto
        bg-surface
        border border-border
        rounded-2xl
        shadow-sm
        p-6 sm:p-8 md:p-10
      "
                >
                    {/* Heading */}
                    <h1
                        id="change-password-heading"
                        className="text-2xl sm:text-3xl font-bold text-textPrimary text-center"
                    >
                        Change Password
                    </h1>

                    {/* Form */}
                    <form
                        onSubmit={handleSubmit}
                        className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6"
                        noValidate
                    >
                        {/* Email */}
                        <div className="sm:col-span-2">
                            <label
                                htmlFor="email"
                                className="block text-sm font-medium text-textPrimary"
                            >
                                Email address
                            </label>
                            <input
                                id="email"
                                type="email"
                                name="toEmail"
                                value={isEmail}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                aria-required="true"
                                placeholder="you@example.com"
                                className="
              mt-2 w-full rounded-lg
              border border-border
              bg-white px-4 py-2.5
              text-textPrimary
              focus:outline-none
              focus-visible:ring-2
              focus-visible:ring-primary-light
            "
                            />
                        </div>

                        {/* Old Password */}
                        <div>
                            <label
                                htmlFor="oldPassword"
                                className="block text-sm font-medium text-textPrimary"
                            >
                                Old password
                            </label>
                            <input
                                id="oldPassword"
                                type="password"
                                name="oldPassword"
                                value={isOldPass}
                                onChange={(e) => setOldPass(e.target.value)}
                                required
                                aria-required="true"
                                className="
              mt-2 w-full rounded-lg
              border border-border
              bg-white px-4 py-2.5
              text-textPrimary
              focus:outline-none
              focus-visible:ring-2
              focus-visible:ring-primary-light
            "
                            />
                        </div>

                        {/* New Password */}
                        <div>
                            <label
                                htmlFor="newPassword"
                                className="block text-sm font-medium text-textPrimary"
                            >
                                New password
                            </label>
                            <input
                                id="newPassword"
                                type="password"
                                name="newPassword"
                                value={isnewPass}
                                onChange={(e) => setnewPass(e.target.value)}
                                required
                                aria-required="true"
                                className="
              mt-2 w-full rounded-lg
              border border-border
              bg-white px-4 py-2.5
              text-textPrimary
              focus:outline-none
              focus-visible:ring-2
              focus-visible:ring-primary-light
            "
                            />
                        </div>

                        {/* Confirm Password */}
                        <div className="sm:col-span-2">
                            <label
                                htmlFor="confirmPassword"
                                className="block text-sm font-medium text-textPrimary"
                            >
                                Confirm new password
                            </label>
                            <input
                                id="confirmPassword"
                                type="password"
                                name="confirmPassword"
                                value={isnewPassConf}
                                onChange={(e) => setnewPassConf(e.target.value)}
                                required
                                aria-required="true"
                                className="
              mt-2 w-full rounded-lg
              border border-border
              bg-white px-4 py-2.5
              text-textPrimary
              focus:outline-none
              focus-visible:ring-2
              focus-visible:ring-primary-light
            "
                            />
                        </div>

                        {/* Submit */}
                        <div className="sm:col-span-2 mt-4">
                            <button
                                type="submit"
                                disabled={loading}
                                className="
              w-full sm:w-auto
              inline-flex justify-center items-center
              rounded-xl
              bg-primary px-8 py-3
              text-sm font-semibold text-white
              hover:bg-primary-dark
              focus-visible:outline-none
              focus-visible:ring-2
              focus-visible:ring-primary-light
              disabled:opacity-60
            "
                            >
                                {loading ? "Submitting..." : "Change Password"}
                            </button>
                        </div>
                    </form>

                    {/* Toast */}
                    <Toast ref={toastBR} position="top-right" />
                    <ToastContainer />
                </main>
            </section>
        );


    }

    export default ChangePassword
